/** MinHub Portal mark — two overlapping rings. Tint with `currentColor`. */
import type { SVGProps } from 'react'

export function PortalIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden
			{...props}
		>
			<circle cx="9" cy="15" r="6" />
			<circle cx="15" cy="9" r="6" />
		</svg>
	)
}
